import {
  PazaramaOrderProduct,
  pazaramaOrderProductFromResponse,
} from './PazaramaOrderProduct';
import { PazaramaOrderStatus } from './PazaramaOrderStatus';

export interface PazaramaOrder {
  pazaramaID: string;
  products: PazaramaOrderProduct[];
  status: PazaramaOrderStatus;
  createdAt: Date;
}

export const pazaramaOrderFromResponse = (
  responseData: any,
): PazaramaOrder => ({
  pazaramaID: responseData.pazarama_id,
  products: (responseData.products ?? []).map(pazaramaOrderProductFromResponse),
  status: responseData.status,
  createdAt: new Date(responseData.created_at),
});
